// Pantalla amigable ante errores de carga (chunks que no llegan por red lenta / servidor arrancando)
// o errores inesperados de render. Reemplaza la pantalla en blanco / overlay técnico.
import React from 'react';
import { RefreshCw, Home, WifiOff, AlertTriangle } from 'lucide-react';

const esErrorDeCarga = (error) =>
  error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk|Failed to fetch dynamically imported module|import\(\)/i.test(String(error?.message || ''));

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const deCarga = esErrorDeCarga(error);
    const sinRed = typeof navigator !== 'undefined' && !navigator.onLine;
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6" data-testid="pantalla-error">
        <div className="max-w-md w-full bg-white rounded-xl shadow border p-6 text-center space-y-4">
          <div className="mx-auto h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
            {sinRed ? <WifiOff className="h-6 w-6 text-amber-700" /> : <AlertTriangle className="h-6 w-6 text-amber-700" />}
          </div>
          <h1 className="text-lg font-semibold text-gray-900">
            {deCarga ? 'No se pudo cargar esta pantalla' : 'Ocurrió un error inesperado'}
          </h1>
          <p className="text-sm text-gray-600" data-testid="pantalla-error-detalle">
            {sinRed
              ? 'Estás sin conexión y esta pantalla todavía no estaba guardada en el dispositivo. Reintentá cuando tengas señal.'
              : deCarga
                ? 'La conexión es lenta o el servidor está iniciando. Tu avance guardado en el dispositivo no se pierde.'
                : String(error?.message || 'Error desconocido')}
          </p>
          <div className="flex gap-2 justify-center">
            <button type="button" onClick={() => window.location.reload()} data-testid="pantalla-error-reintentar"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700">
              <RefreshCw className="h-4 w-4" /> Reintentar
            </button>
            <button type="button" onClick={() => { window.location.href = '/'; }} data-testid="pantalla-error-inicio"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md border text-sm font-medium text-gray-700 hover:bg-gray-50">
              <Home className="h-4 w-4" /> Ir al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
